import styled from "styled-components";

export const PartnerContainer = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
`;
